import { useQuery } from '@tanstack/react-query'
import { datos } from '@/api/origen'
import { descargarArchivo } from '@/api/cliente'
import type { EstadoCuenta, MiSuscripcion } from './tipos'

/**
 * La cuenta con Agentical Group, vista desde el portal. Va contra `/interna/cuenta`,
 * que responde con cualquier rol y **también con la cuenta suspendida**: es por
 * donde se sale de la suspensión.
 */

export const clavesCuenta = {
  todo: ['cuenta'] as const,
  estado: ['cuenta', 'estado'] as const,
  suscripcion: ['cuenta', 'suscripcion'] as const,
}

/**
 * La etapa de la cuenta, para el aviso fijo y para esconder lo que no se puede
 * usar. Se refresca cada cinco minutos y al volver a la pestaña: la etapa
 * cambia a lo sumo una vez al día, pero el pago que registra Agentical Group tiene que
 * quitar el aviso sin que el cliente recargue.
 *
 * **Si no carga, no se asume nada.** La pantalla sigue como si estuviera al
 * día: quien decide si se emite es el servidor al emitir, no esta consulta.
 */
export function useEstadoCuenta() {
  return useQuery({
    queryKey: clavesCuenta.estado,
    queryFn: ({ signal }) => datos.obtener<EstadoCuenta>('/cuenta/estado', { senal: signal }),
    staleTime: 60_000,
    refetchInterval: 300_000,
    refetchOnWindowFocus: true,
    retry: 1,
  })
}

export function useMiSuscripcion() {
  return useQuery({
    queryKey: clavesCuenta.suscripcion,
    queryFn: ({ signal }) => datos.obtener<MiSuscripcion>('/cuenta', { senal: signal }),
  })
}

/** El PDF del e-CF que Agentical Group emitió por un pago. */
export function descargarComprobante(pagoId: string): Promise<void> {
  return descargarArchivo(`/cuenta/pagos/${encodeURIComponent(pagoId)}/comprobante`)
}
